// extracted by mini-css-extract-plugin
export default {"titshare":"index_titshare_z1xoz","vertical":"index_vertical_XOLGX","boxhidden":"index_boxhidden_Z0uiQ"};